import { useMemo } from "react";

export type EngagementBreakdownItem = {
  clicked: number;
  delivered: number;
  label: string;
  percentage: number;
};

type EngagementBreakdownSummary = {
  total: number;
  sortedBreakdown: EngagementBreakdownItem[];
};

export const useEngagementBreakdownSummary = (
  breakdown: EngagementBreakdownItem[],
): EngagementBreakdownSummary =>
  useMemo(() => {
    const firstItem = breakdown[0];

    if (firstItem === undefined) throw new Error("Engagement breakdown data cannot be empty");

    return {
      total: breakdown.reduce((total, item) => total + item.percentage, 0),
      sortedBreakdown: [...breakdown].sort((a, b) => {
        const percentageSort = b.percentage - a.percentage;
        if (percentageSort !== 0) return percentageSort;

        return a.percentage === 0 ? a.delivered - b.delivered : b.delivered - a.delivered;
      }),
    };
  }, [breakdown]);
